var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFireIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14080_3446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5631 11.766L10.7746 9.67461V5.41438C10.7746 4.98602 10.4283 4.63977 9.99995 4.63977C9.57159 4.63977 9.22534 4.98602 9.22534 5.41438V10.062C9.22534 10.3059 9.33999 10.536 9.53519 10.6816L12.6335 13.0054C12.773 13.11 12.9357 13.1604 13.0975 13.1604C13.3338 13.1604 13.5662 13.0542 13.718 12.8497C13.9752 12.5081 13.9055 12.0224 13.5631 11.766Z",
    fill: "url(#paint0_linear_14080_3446)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_14080_3446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.83199 9.75391C2.83199 9.75391 3.62215 10.9147 5.27824 11.8973C5.27824 11.8973 4.07883 1.76051 11.8938 0C9.89156 7.34848 14.4407 9.42086 16.0989 5.53852C18.8682 9.23582 16.7655 12.4615 16.7655 12.4615C17.9011 12.6251 18.8549 11.3846 18.8549 11.3846C18.8634 11.5374 18.8682 11.6912 18.8682 11.8462C18.8682 16.3494 15.2176 20 10.7144 20C6.21113 20 2.56055 16.3494 2.56055 11.8462C2.56055 11.1228 2.65523 10.4216 2.83199 9.75391Z",
    fill: "#FF421D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8549 11.3846C18.8549 11.3846 17.9011 12.6251 16.7656 12.4615C16.7656 12.4615 18.8682 9.23582 16.0989 5.53852C14.4407 9.42086 9.89158 7.34848 11.8938 0C11.4753 0.0942969 11.0828 0.212773 10.7144 0.352266V20C15.2176 20 18.8682 16.3494 18.8682 11.8462C18.8682 11.6912 18.8634 11.5374 18.8549 11.3846Z",
    fill: "#FF421D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.13843 16.424C7.13843 18.3989 8.73944 20 10.7144 20C12.6893 20 14.2903 18.3989 14.2903 16.424C14.2903 15.3669 13.8317 14.417 13.1025 13.7623C11.7199 15.6407 9.74968 12.7914 11.2851 10.7107C11.2851 10.7107 7.13843 11.2303 7.13843 16.424Z",
    fill: "#FFA900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2903 16.424C14.2903 15.3669 13.8317 14.417 13.1025 13.7623C11.7199 15.6407 9.74967 12.7914 11.2851 10.7107C11.2851 10.7107 11.0598 10.739 10.7144 10.848V20C12.6893 20 14.2903 18.3989 14.2903 16.424Z",
    fill: "#FFA900"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14080_3446",
    x1: 9.22534,
    y1: 8.90006,
    x2: 14.02,
    y2: 8.90006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F83600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8C00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14080_3446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_14080_3446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.714355)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireIcon);
export default __webpack_public_path__ + "static/media/FireIcon.9592dcbe.svg";
export { ForwardRef as ReactComponent };